module.exports = {
	"id": "PT",
	"name": "Portugal",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.024708,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.12354,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.008236,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.032944,
			"32": 0.016472,
			"33": 0.008236,
			"34": 0.032944,
			"35": 0.049416,
			"36": 0.107068,
			"37": 0.049416,
			"38": 0.074124,
			"39": 0.098832,
			"40": 0.04118,
			"41": 0.024708,
			"42": 0.032944,
			"43": 0.197664,
			"44": 0.074124,
			"45": 0.08236,
			"46": 0.057652,
			"47": 0.098832,
			"48": 0.115304,
			"49": 3.343816,
			"50": 0.172956,
			"51": 0.691824,
			"52": 0.527104,
			"53": 40.19168,
			"54": 10.550316,
			"55": 0.098832,
			"56": 0.04118,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.008236,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.008236,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.016472,
			"34": 0.008236,
			"35": 0.008236,
			"36": 0.008236,
			"37": 0.016472,
			"38": 0.057652,
			"39": 0.024708,
			"40": 0.024708,
			"41": 0.032944,
			"42": 0.024708,
			"43": 0.115304,
			"44": 0.04118,
			"45": 0.131776,
			"46": 0.098832,
			"47": 0.49416,
			"48": 0.469452,
			"49": 7.527704,
			"50": 0.032944,
			"51": 0.016472,
			"52": null,
			"3.5": null,
			"3.6": 0.016472
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.008236,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.049416,
			"37": 0.016472,
			"38": 0.065888,
			"39": 0.016472,
			"40": 0.560048,
			"41": 0.115304,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.049416
		},
		"safari": {
			"0": null,
			"4": 0.008236,
			"5": 0.049416,
			"6": null,
			"7": 0.016472,
			"8": 0.12354,
			"9": 0.172956,
			"10": 1.762504,
			"3.1": null,
			"3.2": null,
			"5.1": 0.098832,
			"6.1": 0.057652,
			"7.1": null,
			"9.1": 0.815364
		},
		"ios_saf": {
			"8": 0,
			"10": 2.46941692506,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0665479287052,
			"8.1-8.4": 0.122944478455,
			"9.0-9.2": 0.0586524117402,
			"9.3": 0.894825256037
		},
		"android": {
			"3": 0,
			"4": 0.0199624444444,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00249530555556,
			"4.1": 0.0720073888889,
			"4.2-4.3": 0.180018472222,
			"4.4": 0.412794833333,
			"4.4.3-4.4.4": 0.416359555556
		},
		"ie": {
			"6": null,
			"7": 0.0165184,
			"8": 0.2725536,
			"9": 0.3221088,
			"10": 0.165184,
			"11": 5.0876672,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0089970046225,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000249916795069
		},
		"edge": {
			"12": 0.131776,
			"13": 0.733004,
			"14": 2.199012
		},
		"ie_mob": {
			"10": 0.0761318028169,
			"11": 0.309965197183
		},
		"bb": {
			"7": 0.00749275,
			"10": null
		},
		"samsung": {
			"0": 1.249967
		},
		"and_uc": {
			"0": 0.215086
		},
		"op_mini": {
			"0": 0.121215078582
		},
		"and_chr": {
			"0": 12.436337
		},
		"and_ff": {
			"0": 0.019393
		}
	},
	"total": 98.22645975
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PT.json
 ** module id = 628
 ** module chunks = 0
 **/